var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "product-card"
  }, [_c('card-label', {
    attrs: {
      "color": "555555",
      "content": "products"
    }
  }), _c('v-row', {
    staticClass: "ma-0 my-12 product-ctn",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-icon', {
    staticClass: "scan-icon",
    attrs: {
      "size": "48px"
    }
  }, [_vm._v("$product")]), _c('div', {
    staticClass: "pl-3"
  }, [_c('div', {
    staticClass: "number font-weight-bold"
  }, [_vm._v(_vm._s(_vm.productCount))]), _c('div', {
    staticClass: "legend font-weight-bold"
  }, [_vm._v("Products Scanned")])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }